import React from 'react';
import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

import ContentContainer from 'components/content-container/ContentContainer';

const themes = defineTheme({
  sidebarLeft: 'content-with-sidebar--theme-sidebar-left',
  largeDocuments: 'content-with-sidebar--theme-large-documents'
});

type Theme = ThemeKeys<typeof themes>;

interface ContentWithSidebarProps {
  children: React.ReactNode;
  className?: string;
  theme?: Theme;
  useContentContainer?: boolean;
}

const ContentWithSidebar: React.FC<ContentWithSidebarProps> = ({
  children,
  className,
  theme,
  useContentContainer = true
}) => {
  const WrapperElement = useContentContainer ? ContentContainer : React.Fragment;

  return (
    <WrapperElement>
      <div className={cn('content-with-sidebar', themes(theme), className)}>{children}</div>
    </WrapperElement>
  );
};

ContentWithSidebar.displayName = 'ContentWithSidebar';

export default ContentWithSidebar;
